import Activities from "pages/Activities";
import AdvancedTrade from "pages/AdvancedTrade";
import AuthenticationCallBack from "pages/Welcome/AuthenticationCallBack";
import BankAccounts from "pages/BankAccounts";
import BasicTrade from "pages/BasicTrade";
import Convert from "pages/Convert";
import Deposit from "pages/Deposit";
import DesktopLayout from "layouts/Desktop";
import Help from "pages/Help";
import Home from "pages/Home";
import InvestmentFund from "pages/Wallet/InvestmentFund";
// import InvestmentFundDetails from "pages/Wallet/InvestmentFundDetails";
import InvestmentPortfolio from "pages/History/InvestmentHistory/InvestmentPortfolio";
import InvestmentRequest from "pages/History/InvestmentHistory/InvestmentRequest";
import MarginCoinSingle from "pages/Wallet/CoinSingle/MarginCoinSingle";
import MarginHistory from "pages/Wallet/MarginHistory";
import MarginWallet from "pages/Wallet/MarginWallet";
import Market from "pages/Market";
import MobileLayout from "layouts/Mobile";
import Notifications from "pages/Notifications";
import P2P from "pages/P2P";
import PaymentGatewayCallback from "pages/PaymentGatewayCallback";
import Portfolio from "pages/Portfolio";
import PortfolioDetails from "pages/Portfolio/PortfolioDetails";
import React from "react";
import Referral from "pages/Referral";
import ReferralHistory from "pages/ReferralHistory";
import Rules from "pages/Rules";
import SpotCoinSingle from "pages/Wallet/CoinSingle/SpotCoinSingle";
import SpotWallet from "pages/Wallet/SpotWallet";
import TradeHistory from "pages/History/TradeHistory";
import TransferHistory from "pages/History/TransferHistory";
// import ViewFixedYearlyProfit from "pages/Wallet/Component/CreateInvestmentFund/Component/ViewFixedYearlyProfit";
import Welcome from "pages/Welcome";
import Withdraw from "pages/Withdraw";
import WithdrawOrDepositHistory from "pages/History/WithdrawOrDepositHistory";
import { ROUTE_PATHS } from "./paths";
import NotPermittedPage from "pages/NotPermitted";

const isMobileView = window.innerWidth <= 600;

const routes = () => {
  return [
    {
      element: isMobileView ? <MobileLayout /> : <DesktopLayout />,
      order: 0,
      children: [
        { path: "/", element: <Home /> },
        { path: ROUTE_PATHS.notifications, element: <Notifications /> },
        { path: ROUTE_PATHS.market, element: <Market /> },
        { path: "/deposit/:id", element: <Deposit /> },
        { path: "/withdraw/:id", element: <Withdraw /> },
        // {
        //   path: "/investment-fund/investment-fund-details",
        //   element: <InvestmentFundDetails />,
        // },
        // {
        //   path: "/investment-fund/view-fixed-yearly-profit",
        //   element: <ViewFixedYearlyProfit />,
        // },
        { path: ROUTE_PATHS.wallet.investment, element: <InvestmentFund /> },
        { path: "/wallet/spot", element: <SpotWallet /> },
        { path: "/wallet/spot/:id", element: <SpotCoinSingle /> },
        { path: "/wallet/margin", element: <MarginWallet /> },
        { path: "/wallet/margin/:id", element: <MarginCoinSingle /> },
        { path: ROUTE_PATHS.trade.basic(), element: <BasicTrade /> },
        { path: "/rules/:id", element: <Rules /> },
        { path: "/help/:id", element: <Help /> },
        { path: "/referral", element: <Referral /> },
        { path: "/bank-accounts", element: <BankAccounts /> },
        { path: "/referral-history", element: <ReferralHistory /> },
        { path: "/convert", element: <Convert /> },
        { path: "/wallet/margin-history", element: <MarginHistory /> },
        { path: "/activities", element: <Activities /> },
        { path: "/portfolio", element: <Portfolio /> },
        { path: "/p2p", element: <P2P /> },
        { path: "/portfolio-details/:type/:id", element: <PortfolioDetails /> },
        {
          path: ROUTE_PATHS.trade.advanced(),
          element: <AdvancedTrade />,
        },
        {
          path: "/history/trade-history",
          element: <TradeHistory />,
        },
        {
          path: "/history/spot",
          element: <WithdrawOrDepositHistory hideTypeTabs showWalletType show24h={false} />,
        },
        {
          path: ROUTE_PATHS.history.request,
          element: <InvestmentRequest />,
        },
        {
          path: ROUTE_PATHS.history.investment,
          element: <InvestmentPortfolio />,
        },
        {
          path: ROUTE_PATHS.history.transfer,
          element: <TransferHistory />,
        },
        {
          path: "/PaymentGatewayCallback",
          element: <PaymentGatewayCallback />,
        },
        {
          path: ROUTE_PATHS.not_permitted,
          element: <NotPermittedPage />,
        },
      ],
    },

    {
      path: "*",
      element: <Welcome />,
      order: 0,
    },
    {
      path: "/authentication/callback",
      element: <AuthenticationCallBack />,
      order: 0,
    },
    // {
    //   path: "GeneralComponents",
    //   element: <GeneralComponents />,
    //   order: 0,
    // },
  ];
};

export default routes;
